import { get_project_ref, get_draft_ref } from './service-routing-legacy';
import { logged_in, project_list } from '../app-store';
import env from './environment.js';


function bootstrap_app(callback) {

	/**
	 * ==============================================================================
	 * Core variables existing before svelte router
	 * ==============================================================================
	 */

	window.app = window.app || {};
	window.app.storage = window.create_storage("lucep-ai");
	window.app.creds = window.app.storage.get("creds");
	window.app.global_state = {};
	window.app.cache_imgs = {
		folder_spinner: window.tag.img({ src: "/img/loader-2-line.svg", width: "16", height: "16" }),
	};
	// Lucep AI API
	window.app.lucep_ai = new window.LucepAI(env.apiUrl, env.recaptch_key);
	window.app.lucep_ai.set_auth(window.app.creds);


	// Spinner - OK TO KEEP GLOBAL FOR NOW, THEY ARE CLOSURES THAT APPEND/REMOVE DOM EL
	window.app.btn_spinner = window.create_spinner();
	window.app.body_spinner = window.create_spinner({ classname: "body-spinner" });


	// Modal - GOES TO THE BODY - ANYWHERE AS ITS A MODAL (ONLY USED TO RENAME DRAFT)
	window.app.modal = new window.web_svelte.Modal({
		target: document.body,
		props: {
			id: "modal",
			title: "Modal Title",
		}
	});


	// Build Toast - GOES TO THE BODY - ANYWHERE AS ITS A MODAL
	window.app.toast_msg = new window.Toast({ duration: 5000 });
	window.app.toast_msg.render();


/**
 * ==============================================================================
 * "Global" COMPONENTS from MAIN
 * -> to add individual comps
 * 1. sidebar
 * 2. header
 * 3. app-screen/app_container_el -> routed pages
 * 4. chat-container (right bar)
 * ==============================================================================
 */

	//  used for the first load and after a new draft is created (to update list)
	window.app.init_sidebar_items = async () => {
		if (window.app.global_state.sidebar_initialized)
			return;
		try {
			const { status, projects } = await window.app.lucep_ai.get_projects();

			if (status !== "ok") {
				console.error("Error fetching Projects");
				throw new Error("Error fetching Projects");
			}

			// Initialize the active list
			project_list.set(projects.map((p) => ({
				...p,
				is_active: p.project_ref === get_project_ref(),
				drafts: p.drafts.map((d) => ({
					...d,
					is_active: d.refcode === get_draft_ref()
				}))
			})));

			window.app.global_state.sidebar_initialized = true;
		} catch (error) {
			console.error(error);
			if (error.status_code === 500) {
				window.app.chat_manager.send_alert(error_msg.server_error(error.msg));
			} else {
				window.app.chat_manager.send_alert(error_msg.client_error(error.msg));
			}
		}
	};

	// Page load
	window.app.init = async function () {

		// TODO: how to redirect this auth to a responsive store?
		// - try to move these spinners to proper pages? just keeping the sidebar loading?

		if (window.app.creds && window.app.creds.authtoken) {
			window.app.body_spinner.add_to(document.body);
			window.app.body_spinner.set_message("Loading...");
			await window.app.init_sidebar_items();
			logged_in.set(true);
		} else {
			logged_in.set(false);
		}

		callback();
	};

	window.app.init();
}

export { bootstrap_app };
